class TreeTypeModal {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const modalToggle = '.js-treetype-modal-toggle';
    const modalWrap = '.js-treetype-modal';
    const modalClose = '.js-treetype-modal-close';
    const modalContent= '.js-treetype-modal-content';
    $(modalToggle).on('click',function(){
      let modalNum = $(this).data('modal');
      $(modalWrap).find('[data-modal='+modalNum+']').css('visibility','visible');
      $(modalWrap).fadeIn();
    })
    $(modalClose).on('click',function(){
      $(modalWrap).fadeOut();
      setTimeout(function(){
        $(modalContent).css('visibility','hidden');
      },500)
    })
  }
}